import { render, staticRenderFns } from "./GalleryColumnsDialog.vue?vue&type=template&id=295dbeb6&scoped=true&"
import script from "./GalleryColumnsDialog.vue?vue&type=script&lang=js&"
export * from "./GalleryColumnsDialog.vue?vue&type=script&lang=js&"
import style0 from "./GalleryColumnsDialog.vue?vue&type=style&index=0&id=295dbeb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295dbeb6",
  null
  
)

export default component.exports